import React, { useState } from 'react';
import './Form.css';
import './VisitorInfo.css';
import logo from './logo.png';
import { useEffect } from 'react';

function PassportForm({ onNext, setNumVisitors }) {
  const [numVisitors, setnumVisitors] = useState(1);

  const handleNumVisitorsChange = (event) => {
    const newNumVisitors = parseInt(event.target.value);
    setnumVisitors(newNumVisitors);
    setNumVisitors(newNumVisitors);
  };

  const [passportNumber, setPassportNumber] = useState('');
  const [nationality, setNationality] = useState('MX');
  const [email, setEmail] = useState('');
  const [selectedEmailOption, setSelectedEmailOption] = useState({});

  useEffect(() => {
    setSelectedEmailOption(() => {
      return Array.from({ length: numVisitors }, (_, i) => (i > 0 ? 'first' : undefined)).reduce((obj, value, index) => {
        if (value) {
          obj[index] = value;
        }
        return obj;
      }, {});
    });
  }, [numVisitors]);

  const handleEmailOptionChange = (index, event) => {
    setSelectedEmailOption({ ...selectedEmailOption, [index]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic here
    console.log('Passport Number:', passportNumber);
    console.log('Nationality:', nationality);
    console.log('Email:', email);
  };

  return (
    <div className='body'>
      <div className="header-container">
        <img src={logo} alt="Puerto Vallarta Logo" style={{ width: '350px' }} />
        <h3>Impuesto de visitantes extranjeros</h3>
        <div className="price-container" style={{ backgroundColor: 'rgb(226, 207, 167)', display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
          <p className="price-text" style={{ textAlign: 'left' }}>$150 MXN por pasajero</p>
        </div>
      </div>
      <div className="visitor-info">
        <label htmlFor="numVisitors">Número de Visitantes:</label>
        <button type="button" onClick={() => {
          setnumVisitors(numVisitors - 1);
          setNumVisitors(numVisitors - 1);
        }} disabled={numVisitors <= 1}>
          -
        </button>
        <input
          type="number"
          id="numVisitors"
          value={numVisitors}
          onChange={handleNumVisitorsChange}
          min="1"
        />
        <button type="button" onClick={() => {
          setnumVisitors(numVisitors + 1);
          setNumVisitors(numVisitors + 1);
        }}>
          +
        </button>
      </div>
      <div className="visitor-info">
        <label htmlFor="arrivalDate">Fecha de Llegada:</label>
        <input
          type="date"
          id="arrivalDate"
          min={new Date().toISOString().split('T')[0]}
          defaultValue={new Date().toISOString().split('T')[0]}
        />
      </div>

      {Array.from({ length: numVisitors }, (_, index) => (
        <form key={index} onSubmit={handleSubmit} className="passport-form">
          <h3>Visitante #{index + 1}</h3>
          <div>
            <label htmlFor="passportNumber">Número de Pasaporte:</label>

          </div>
          <input
            type="text"
            id="passportNumber"
            // value={passportNumber}
            // onChange={(e) => setPassportNumber(e.target.value)}
              placeholder="123456789"
              pattern="[0-9]*"
          />
          <div>
            <label htmlFor="nationality">Nacionalidad:</label>
          </div>
          <select
            id="nationality"
            
            onChange={(e) => setNationality(e.target.value)}
            style={{padding: '10px', marginBottom: '15px', border: '1px solid #ccc', borderRadius: '5px'}}
          >
            <option value="">Selecciona una nacionalidad</option>
            <option value="MX">MX</option>
            <option value="US">US</option>
            <option value="CA">CA</option>
            <option value="GB">GB</option>
            <option value="Other">Otra</option>
          </select>
          <div >
            <label>Correo:</label>
          </div>
          <div  >
            {index > 0 ? (
              <div className="email-options ">
                <p>¿Deseas recibir el comprobante de pago en el correo asociado al pasajero #1?</p>
                <label>
                  <input type="radio" name={`emailOption-${index}`} value="first" checked={selectedEmailOption[index] === 'first'} onChange={(e) => handleEmailOptionChange(index, e)} />
                  Sí, quiero recibir el comprobante de pago solo en el correo del primer pasajero
                </label>
                <label>
                  <input type="radio" name={`emailOption-${index}`} value="additional" checked={selectedEmailOption[index] === 'additional'} onChange={(e) => handleEmailOptionChange(index, e)} />
                  No, deseo recibir el comprobante de pago en un correo adicional
                </label>
                {selectedEmailOption[index] === 'additional' && (
                  <input
                    
                    id={`additionalEmail-${index}`}
                      className="email-input"
                    placeholder="example@domain.com"
                  />
                )}
              </div>
            ) : (
              <div >
              <input
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
                placeholder="example@domain.com"
                autocomplete="off"
              />
              </div>
            )}
          </div>
        </form>
      ))}
      <button type="submit" onClick={onNext}>Siguiente</button>
      <footer>
        <p>PRESIDENCIA MUNICIPAL: Independencia #123, Col. Centro, C.P. 48300, Puerto Vallarta. Teléfono: 322 222 0102 y 322 223 2500</p>
        <p>UNIDAD MUNICIPAL ADMINISTRATIVA: Av. Mezquital #604, Col. Portales, C.P.48315, Puerto Vallarta. Teléfonos: 322 178 8000 y 322 226 8080</p>
      </footer>
    </div>
  );
}

export default PassportForm;
